module.exports = __webpack_public_path__ + "media/images/application/icons/arrow-pagination-600ee40a8482d49a28d3a8b68a87282b.svg";